import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "market-header-mobile" }
const _hoisted_2 = { class: "market-header-mobile__name" }
const _hoisted_3 = { class: "market-header-mobile__info" }

import { computed } from 'vue';
import type { PropType } from 'vue';

import type { MarketModel } from '@exchange/libs/market/service/src';
import { MarketType } from '@exchange/libs/market/service/src/lib/market-model';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'MarketHeaderMobile',
  props: {
  market: { type: Object as PropType<MarketModel>, required: true },
},
  setup(__props) {

const props = __props;

const baseCode = computed(() => props.market.base.code);
const quoteCode = computed(() => props.market.quote.code);
const lastPrice = computed(() => props.market.lastPrice);
const priceChangePercentage = computed(() => props.market.priceChangePercentageToDisplay);
const marketTitle = computed(() => props.market.name);

const percentagePrecision = CONSTANTS.PRECISION.DEFAULT_PERCENTAGE;

return (_ctx: any,_cache: any) => {
  const _component_x_logo = _resolveComponent("x-logo")!
  const _component_ot_lozenge = _resolveComponent("ot-lozenge")!
  const _component_ot_number_display = _resolveComponent("ot-number-display")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_x_logo, {
      key: marketTitle.value,
      class: "market-header-mobile__logo",
      name: baseCode.value,
      type: "crypto"
    }, null, 8, ["name"])),
    _createElementVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(marketTitle.value) + " ", 1),
      (__props.market.type === _unref(MarketType).PERP)
        ? (_openBlock(), _createBlock(_component_ot_lozenge, {
            key: 0,
            uppercase: false,
            filled: false,
            text: _ctx.$t('fundamentals.perpetual.short'),
            class: "market-header-mobile__name__lozenge"
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ot_number_display, {
        class: "market-header-mobile__price",
        precision: __props.market.marketPrecision,
        number: lastPrice.value,
        suffix: quoteCode.value,
        "smaller-suffix": true,
        grouping: true
      }, null, 8, ["precision", "number", "suffix"]),
      _createVNode(_component_ot_number_display, {
        class: "market-header-mobile__change",
        precision: _unref(percentagePrecision),
        number: priceChangePercentage.value,
        "add-plus-sign": true,
        percentage: true,
        "colored-percentage": true
      }, null, 8, ["precision", "number"])
    ])
  ]))
}
}

})